import {
  compactCents,
  formatBps,
  formatCivilDate,
  formatCompetenceShort,
} from "../../../utils/directorFormat";

// Só apresentação: todo indicador chega pronto do BE (centavos e bps).
const isCents = (value) => Number.isSafeInteger(value);

export const money = (cents) => (isCents(cents) ? compactCents(cents) : "—");

export const signedMoney = (cents) => (isCents(cents) ? `${cents > 0 ? "+" : ""}${compactCents(cents)}` : "—");

export const percent = (bps) => (Number.isSafeInteger(bps) ? formatBps(bps) : "—");

export const annualRate = (bps) => (Number.isSafeInteger(bps) ? `${formatBps(bps)} a.a.` : "—");

export const monthLabel = (month) => (
  typeof month === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(month) ? formatCompetenceShort(month) : "—"
);

export const civilDate = (value) => (typeof value === "string" ? formatCivilDate(value.slice(0, 10)) : "—");

const pointsFormatter = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 1 });

export const pointsDiff = (fromBps, toBps) => (
  Number.isSafeInteger(fromBps) && Number.isSafeInteger(toBps)
    ? `${pointsFormatter.format((toBps - fromBps) / 100)} p.p.`
    : "—"
);

// Razão para exibição (ex.: estouro sobre o orçado), em bps.
export const shareBps = (part, whole) => (
  isCents(part) && isCents(whole) && whole !== 0 ? Math.round((part / whole) * 10000) : null
);

export const addMonths = (month, count) => {
  const [year, value] = month.split("-").map(Number);
  const index = year * 12 + value - 1 + count;
  return `${Math.floor(index / 12)}-${String((index % 12) + 1).padStart(2, "0")}`;
};

export const SITUATIONS = {
  check_cost: { label: "Conferir custo", tone: "warn" },
  critical: { label: "Crítica", tone: "bad" },
  attention: { label: "Atenção", tone: "warn" },
  healthy: { label: "Saudável", tone: "good" },
  company_expenses: { label: "Despesa da empresa", tone: "muted" },
};

export const OVERHEAD_KEY = "__company_expenses";

// Linhas do escopo: obras e, no escopo "Tudo", as despesas da empresa.
export const scopeRows = (data) => {
  const obras = (data?.obras || []).map((obra) => ({ ...obra, key: obra.projectKey, overhead: false }));
  if (data?.scopeMode !== "all" || !data?.overhead) return obras;
  return [...obras, {
    ...data.overhead,
    key: OVERHEAD_KEY,
    projectKey: null,
    name: "Despesas da empresa",
    overhead: true,
    hasStock: false,
    situation: "company_expenses",
  }];
};

export const blockAvailable = (data, block) => data?.blocks?.[block]?.available !== false;

// Motivo do bloco indisponível (ex.: "capability_missing", "costs_unavailable"); null se disponível.
export const blockReason = (data, block) => (blockAvailable(data, block) ? null : data.blocks[block].reason ?? null);

export const COSTS_UNAVAILABLE = "Custos do Ampli Obras indisponíveis agora.";
